import { SET_CURRENT_USER }	from '../actions/UstateActions';

export default function ustate( prevState = { id: 0 }, action ) {
	switch (action.type) {
		case SET_CURRENT_USER:
			return {
				...prevState,
				...action.ustate
			};

		default:
			return prevState;
	}
}



// WEBPACK FOOTER //
// ./common/reducers/ustate.js